<template>
  <div class="bt-device-info">
    <div v-if="hasBackground" class="bt-device-info__illustration">
      <img class="bt-device-info__illustration-img" :src="bgImage" />
    </div>
    <div class="bt-device-info__device-card">
      <div class="bt-device-info__device-main">
        <span class="bt-device-info__device-icon">
          <i class="icon-patchtalk-ai-line t-iconfont"></i>
        </span>
        <span class="bt-device-info__device-info">
          <span class="bt-device-info__device-name">{{ deviceName }}</span>
          <span class="bt-device-info__device-id">{{ deviceId }}</span>
        </span>
        <span class="bt-device-info__status" :class="connected && 'connected'">
          <span class="bt-device-info__status-dot"></span>
          <span class="bt-device-info__status-text">{{ statusText }}</span>
        </span>
      </div>
      <!-- 电量/容量仅连接态展示，断开态不渲染该行 -->
      <div v-if="connected" class="bt-device-info__device-extra">
        <span class="bt-device-info__battery">
          <i class="icon-battery-low-line t-iconfont"></i>
          <span class="bt-device-info__battery-text">{{ batteryText }}</span>
        </span>
        <span class="bt-device-info__storage">
          <span class="bt-device-info__storage-label">剩余容量：</span>
          <span class="bt-device-info__storage-value">{{ storageText }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const bgImage = require('@//assets/nveasy-bluetooth/device-bg.png')

const props = defineProps({
  hasBackground: {
    type: Boolean,
    default: true
  },
  deviceInfo: {
    type: Object,
    default: () => ({})
  },
  // 连接状态：驱动状态文案与状态点颜色
  // 是否展示电量/容量行（仅已连接态需要）
  connected: Boolean
})

const deviceName = computed(() => props.deviceInfo.name || '--')
const deviceId = computed(() => props.deviceInfo.deviceId || props.deviceInfo.mac || '--')
const statusText = computed(() => (props.connected ? '已连接' : '未连接'))
const batteryText = computed(() => {
  const val = props.deviceInfo?.queryBattery?.caseBattery
  return val ? `${val} %` : '--'
})
const storageText = computed(() => {
  const val = props.deviceInfo?.queryStorage?.freeSpace
  return val ? `${val} KB` : '--'
})
</script>

<style lang="scss" scoped>
.bt-device-info {
  width: 100%;
  text-align: center;

  &__illustration {
    position: relative;
    width: 240px;
    height: 240px;
    margin: 0 auto -66px;
    overflow: hidden;
    box-sizing: border-box;
    background: transparent;
    border-radius: 32px;
    box-shadow: 0 2px 30px 2px rgba(0, 0, 0, 0.06);
    &-img {
      box-sizing: border-box;
      border: 1px solid #fff;
      width: 100%;
      background: transparent;
      height: 90%;
    }
  }

  &__device-card {
    z-index: 0;
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 16px;
    border-radius: 16px;
    background: #fff;
    box-sizing: border-box;
    text-align: left;
  }

  &__device-main {
    display: flex;
    align-items: center;
    min-height: 40px;
  }

  &__device-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-right: 16px;
    border-radius: 12px;
    color: #323233;
    background: #f7f8fa;
    flex-shrink: 0;

    .t-iconfont {
      font-size: 20px;
      line-height: 20px;
    }
  }

  &__device-info {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
  }

  &__device-name {
    color: #323233;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }

  &__device-id {
    margin-top: 4px;
    color: #969799;
    font-size: 12px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__status {
    display: flex;
    align-items: center;
    margin-left: 16px;
    border-radius: 999px;
    flex-shrink: 0;

    &.connected {
      .bt-device-info__status-dot {
        background: #00c241 !important;
      }
      .bt-device-info__status-text {
        color: #323233 !important;
      }
    }

    &-dot {
      width: 4px;
      height: 4px;
      margin-right: 8px;
      border-radius: 50%;
      background: #969799;
    }

    &-text {
      color: #969799;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &__device-extra {
    display: flex;
    align-items: center;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f2f3f5;
  }

  &__battery {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    color: #323233;

    .t-iconfont {
      margin-right: 4px;
      font-size: 16px;
      line-height: 16px;
    }
  }

  &__battery-text {
    font-size: 14px;
    line-height: 20px;
  }

  &__storage {
    display: flex;
    align-items: center;
    margin-left: 16px;
    flex-shrink: 0;
    font-size: 14px;
    line-height: 20px;
  }

  &__storage-label {
    color: #646566;
  }

  &__storage-value {
    margin-left: 4px;
    color: #323233;
  }
}
</style>
